import { Component, Injector, Input, OnInit } from '@angular/core';
import { GridActionHandlerBase } from '../../../../../components/common/grid-base/actions/grid-action-handler-base';
import { ItemSavedReloadGridActionHandler } from '../../../../../components/common/grid-base/actions/itam-saved-reload-grid-action-handler';
import { LoadDataGridActionHandler } from '../../../../../components/common/grid-base/actions/load-data-grid-action-handler';
import { SearchGridActionHandler } from '../../../../../components/common/grid-base/actions/search-grid-action-handler';
import { UnselectCheckboxesGridActionHandler } from '../../../../../components/common/grid-base/actions/unselect-checkboxes-grid-action-handler';
import { WorkspaceBase } from '../../../../../components/common/workspace-base/workspace-base';

/**
 * Comparables leases workspace component
 */
@Component({
  selector: 'comparables-leases-workspace',
  templateUrl: './comparables-leases-workspace.component.html',
  styleUrls: ['./comparables-leases-workspace.component.css']
})
export class ComparablesLeasesWorkspaceComponent extends WorkspaceBase implements OnInit {
  /**
   * JavaScript Oid property name of BO (in this case Lease DTO)
   */
  public oidPropertyName = "oid";

  /**
   * Show the form
   * @param oid Oid of the item that should be loaded in the form. Use -1 for new mode
   */
  public showForm(oid: number): void {
    this.showGrid = false;
    this.oid = oid;

    this.eventBus.broadcastEvent('searchBarVisibility', false);
  }

  /**
   * The workplace
   */
  private _workplace: any;

  /**
   * Sets the workplace
   */
  @Input() public set workplace(workplace: any) {
    this._workplace = workplace;
  }

  /**
   * Gets the workplace
   */
  public get workplace(): any {
    return this._workplace;
  }

  /**
   * The tab element
   */
  private _tabElement: any;

  /**
   * Sets te tab element
   */
  @Input() public set tabElement(tabElement: any) {
    this._tabElement = tabElement;
  }

  /**
   * Gets the tab element
   */
  public get tabElement(): any {
    return this._tabElement;
  }

  /**
   * Constructor
   * @param injector The Angular injector
   */
  constructor(protected injector: Injector) {
    super(injector);
  }

  /**
   * Called if the grid state was changed. Use this to notify the nav bar or perform similar actions
   * @param gridState The new grid state: true: Grid is shown, so the form isn't showh. False: Grid isn't show, but the form is shown
   */
  protected onShowGridChanged(gridState: boolean): void {
    this.eventBus.broadcastEvent('showGridChanged', { area: 'tabLeases', value: gridState });
  }

  /**
   * Gets the action handlers
   */
  protected get actionHandlers(): GridActionHandlerBase[] {
    return [
      new SearchGridActionHandler(this.injector, this, 'comparables.leases.search'),
      new LoadDataGridActionHandler(this.injector, this, 'leases.loadData'),
      new ItemSavedReloadGridActionHandler(this.injector, this, 'comparables.leases.saved'),
      new ItemSavedReloadGridActionHandler(this.injector, this, 'leaseTransactionDataSaved'),
      new UnselectCheckboxesGridActionHandler(this.injector, this)
    ];
  }

  /**
   * Registers any required events. Please don't forget to unsubscibe!
   */
  protected registerEvents(): void {
    this.onEvents.push(this.eventBus.subscribeEvent('comparables.leases.showAll', (_) => {
      this.grid.showAll(null);
    }));

    this.onEvents.push(this.eventBus.subscribeEvent('comparablesTabSelect', (item) => {
      if (item === 'tabLeases') {
        this.oid = null;
        this.showGrid = true;
      }
    }));

    this.onEvents.push(this.eventBus.subscribeEvent('createLeaseTransactionDataFromNav', () => {
      this.showGrid = false;
      this.oid = null;
      this.eventBus.broadcastEvent('createLeaseTransactionData', this.grid.selectedItem);
    }));

    this.onEvents.push(this.eventBus.subscribeEvent('deleteLease', () => {
      const oids = this.getCheckedItems();

      if (oids.length === 0) {
        this.eventBus.broadcastEvent("openConfirmDialog", {
          success: () => {
            //Nothing
          }
        }, 'noDeleteNothingSelected');
      }
      else {
        const options = {
          type: 'comparablesLeaseTransaction'
        };

        this.eventBus.broadcastEvent('deleteComparablesConfirmation', oids, options);
      }
    }));

    this.onEvents.push(this.eventBus.subscribeEvent('closeLeaseForm', () => {
      this.showGrid = true;
      this.oid = null;
      this.eventBus.broadcastEvent('showSaveCancelNavigationAction', false);
    }));

    this.onEvents.push(this.eventBus.subscribeEvent('createLeaseTransactionData', () => {
      this.showForm(-1);
    }));

    this.onEvents.push(this.eventBus.subscribeEvent('backClickedTrue', () => { this.showGrid = true; }));
  }

  /**
   * Applies a filter if an element was selected in a higher hierarchy area
   * @param item Item
   * @param selectedHierarchy Hierarchy where the element was selected
   * @param tabConfig Tab config
   * @param reset Reset the selection in the current area
   */
  public filter(item: any, selectedHierarchy: number, tabConfig: any, reset: boolean): void {
    if (reset) {
      this.grid.loadData({
        skip: 0
      }, null);
    }
    else if (selectedHierarchy != null) {
      const filteredTab = tabConfig[selectedHierarchy];

      if (filteredTab.searchMode === 'comparablesProperty') {
        this.grid.loadData({
          skip: 0,
          filter: {
            logic: 'and',
            filters: [{ field: "PropertyId", operator: "eq", value: item.Oid }]
          }
        }, null);
      }
      else {
        this.grid.loadData({
          skip: 0
        }, null);
      }
    }
  }

  /**
   * Initializes the component
   */
  ngOnInit(): void {
    this.init();

    this.workplace.onTabCreated(this);
  }

}
